<template>
  <div class="multiple-wrap">
    <div class="mul-head">
      <span
        :class="item==activeShow?'mul-head-item active':'mul-head-item'"
        v-for="item in headData"
        :key="item"
        @click="chooseHead(item)"
      >{{item}}</span>
    </div>
    <div class="mul-content">
      <div class="content-title"><span v-if="curItems.length>0">已选条件</span></div>
      <div class="cur-content" v-if="curItems.length>0">
        <div class="cur-item" v-for="(item,index) in curItems" :key="index" v-if="item.name">
          {{item.name}}
          <span
            style="padding-left:10px"
            @click="removeCurItem(item,index)"
          >X</span>
        </div>
        <div @click="removeAllCurItem" class="remove-item-all">全部清除</div>
      </div>
    </div>
    <div class="mul-footer">
      <div v-for="item in footerData" :key="item"  v-if="item!=='认证领域'||multipleData[activeShow][item].length>0">
        <div class="footer-title">
          <div v-if="item!=='条件'&&item!=='技术能力'" class="footer-title-name">{{item}}</div>
          <span
            v-if="item!=='认证领域'"
            v-for="items in multipleData[activeShow][item]"
            @click="pushCurItem(items,item)"
            :key="items.name"
          >{{items.name?items.name:items.id}}</span>
          <div class="domain-cer" v-if="item==='认证领域'">
            <select
              @change="changeSelect()"
              v-model="selectName"
              class="item-select"
              v-if="item==='认证领域'&&multipleData[activeShow][item].length>0"
            >
              <option
                :value="items.name"
                v-for="items in multipleData[activeShow][item]"
                :key="items.name"
              >{{items.code}}{{items.name?items.name:items.id}}</option>
            </select>
          </div>
          <div style="height:182px;" v-if="item=='条件'">
            <!-- <select @change='changeSelect()' v-model="selectName" class="item-select" v-if="item==='认证领域'&&multipleData[activeShow][item].length>0">
           <option :value="items.name" v-for="items in multipleData[activeShow][item]" :key="items.name">{{items.name?items.name:items.id}}</option>
            </select>-->
            <div class="flex-content">
              <div class="inline-item">
                <label>证书编号:</label>
                <input v-model="paramsData.cerNumber" type="text" />
              </div>
              <div class="inline-item">
                <label>机构名称:</label>
                <input v-model="paramsData.name" type="text" />
              </div>
              <div class="inline-item">
                <label>所属系统:</label>
                <input v-model="paramsData.ownSystem " type="text" />
              </div>
              <div class="inline-item">
                <label style="padding-right:27px">地址:</label>
                <input v-model="paramsData.address " type="text" />
              </div>
              <div class="inline-item">
                <label>发放日期:</label>
                <div class="date-picker">
                  <vue-datepicker-local format="YYYY-MM-DD" v-model="paramsData.issueDate"></vue-datepicker-local>
                </div>
              </div>
            </div>
            <div class="button-wraper">
              <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{normalListData.length}}条记录
                </span>
              </div>
              <div class="button-content">
                <button class="primary" @click="handleSearch">查询</button>
                <button class="normal" @click="reset">重置</button>
              </div>
            </div>
          </div>
           <div style="height:130px;" v-if="item=='技术能力'">
            <div class="flex-content" style="height:70px">
              <div style="width:400px" class="inline-item">
                <label>被测（参量/仪器/物质):</label>
                <input v-model="paramsSecondData.measureObject" type="text" />
              </div>
              <div class="inline-item">
                <label>机构名称:</label>
                <input v-model="paramsSecondData.organName" type="text" />
              </div>
            </div>
            <div style="width:1000px" class="button-wraper">
              <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{normalListData.length}}条记录
                </span>
              </div>
              <div class="button-content">
                <button class="primary" @click="handleSecondSearch">查询</button>
                <button class="normal" @click="secondReset">重置</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
  name: 'multipleFilter',
  components: {
    VueDatepickerLocal
  },
  props: {
    // multipleData: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   }
    // }
  },
  data () {
    return {
      headData: [],
      curItems: [],
      listParams: {},
      keyValue: [],
      selectName: '',
      parentCer: '',
      paramsData: {
        issueDate: ''
      },
      itemObjData: {},
      paramsSecondData: {}
    };
  },
  created () {
    // this.fetchSelect()
    this.inintFilterList();
  },
  mounted () {
    // if (this.$store.state.isSliderNav) {
    this.chooseHeadInit(this.$store.state.multipleValue ? this.$store.state.multipleValue : this.headData[0])
    // }
  },
  computed: {
    currentFilterValue: function () {
      return this.$store.state.currentFilterValue;
    },
    multipleData: function () {
      return this.$store.state.multipleData;
    },
    normalListData () {
      return this.$store.state.normalListData;
    },
    normalListDataPage () {
      return this.$store.state.normalListDataPage;
    }
  },
  watch: {
    multipleData () {
      this.headData = [];
      this.curItems = [];
      this.listParams = {};
      this.inintFilterList();
    },
    // multipleValue (val) {
    //   this.chooseHead(val)
    // },
    listParams (value) {
      this.$store.commit('saveListParams', value);
    },
    // 'listParams.category': {
    //   handler: function (val) {
    //     if (!val) {
    //       this.multipleData['认证机构']['认证领域'] = []
    //     }
    //   }
    // },
    activeShow (value) {
      this.$store.commit('updateHead', value);
    },
    curItems (curItemsValue) {
      if (curItemsValue.length > 0) {
        curItemsValue.forEach(element => {
          if (element.type === 'state') {
            this.listParams.state = element.id;
          }
          if (element.type === 'trade') {
            this.listParams.trade = element.id;
          }
          if (element.type === 'level') {
            this.listParams.level = element.id;
          }
          if (element.type === 'provinceCode') {
            this.listParams.provinceCode = element.code;
          }
          if (element.type === 'domain') {
            this.listParams.domain = element.id;
          }
          if (element.type === 'category') {
            this.listParams.category = element.name;
          }
        });
        this.fetchList();
      } else {
        if (!this.$store.state.isTopNav) {
          this.fetchList();
        }
      }
    },
    currentFilterValue () {}
  },
  methods: {
    changeSelect () {
      this.pushCurItem(
        { id: this.selectName, name: this.selectName, type: 'domain' },
        '认证领域'
      )
    },
    dateFormat (val) {
      if (val) {
        let dataFormat = new Date(val)
        let year = dataFormat.getFullYear().toString();
        let month = dataFormat.getMonth() >= 9
          ? (dataFormat.getMonth() + 1).toString()
          : '0' + (dataFormat.getMonth() + 1);
        let date = dataFormat.getDate() >= 9
          ? dataFormat.getDate().toString()
          : '0' + dataFormat.getDate();
        return year + '-' + month + '-' + date;
      }
    },
    inintFilterList () {
      this.headData = Object.keys(this.multipleData);
      this.activeShow = this.headData[0];
      this.footerData = Object.keys(this.multipleData[this.activeShow]);
    },
    fetchSelect (id) {
      this.curItems.forEach(element => {
        if (element.type === 'domain') {
          this.curItems.splice(this.curItems.indexOf(element), 1)
          this.selectName = ''
          delete this.listParams.domain
        }
      });
      let url = '/cer/authField/alllist?code=' + id;
      this.post(url).then(res => {
        this.multipleData['认证机构']['认证领域'] = res.data;
      });
      // this.verify(
      //   'post',
      //   url,
      //   {},
      //   res => {
      //     // this.multipleData['认证机构']['认证领域'] = res.data;
      //   }
      // );
    },
    deleteEmptyProperty (object) {
      Object.keys(object).forEach(element => {
        if (object[element] === '') {
          delete object[element]
        }
      });
    },
    fetchList () {
      let url = '';
      switch (this.currentFilterValue) {
        case '计量':
          url = '/cal/calOrgan/list';
          break;
        case '标准':
          url = '/sta/sta/list';
          break;
        case '检验检测':
          url = '/ins/insOrgan/list';
          break;
        case '认证认可':
          url = '/cer/cerOrgan/list';
          break;
        case '法律':
          url = '/law/lawLegal/list';
          break;
        case '法规':
          url = '/law/lawAdminRegular/list';
          break;
        case '新闻动态':
          url = '/sys/sysNotice/list';
          break;
        default:
          url = 'mul-none';
          break;
      }
      if (this.activeShow === '国家标准') {
        this.listParams.category = '2'
      }
      if (this.activeShow === '服务能力') {
        url = '/cal/technicalCapacity/list'
      }
      if (this.activeShow === '法规') {
        url = '/law/lawAdminRegular/list'
      }
      if (this.activeShow === '法律') {
        url = '/law/lawLegal/list'
      }
      if (this.$store.state.activeShow === '政务') {
        this.listParams.fistThemeName = '政务'
      }
      if (this.$store.state.activeShow === '要闻') {
        this.listParams.fistThemeName = '要闻'
      }
      if (this.$store.state.searchInputValue) {
        if (this.activeShow === '服务能力') {
          this.listParams.measureObject = this.$store.state.searchInputValue;
        } else {
          this.listParams.name = this.$store.state.searchInputValue;
        }
      } else {
        if (!this.listParams.name) {
          delete this.listParams.name;
        }
      }
      // this.$store.commit('saveNormalListData', []);
      // this.$store.commit('saveVisible', true);
      // let a = this
      this.deleteEmptyProperty(this.listParams)
      let params = this.listParams
      this.verify(
        'post',
        url,
        { query: params || {},
          page: {
            currPage: 1,
            pageSize: 10
          } },
        res => {
          if (this.itemName === '认证类别') {
            this.fetchSelect(this.itemObjData.id);
          }
          this.$store.commit('saveNormalListData', res.data.list);
          this.$store.commit('saveNormalListDataPage', res.data.page);
        }
      );
    },
    chooseHead (item) {
      if (item) {
        this.curItems = [];
        this.keyValue = [];
        this.listParams = {}
        this.activeShow = item;
        this.$store.commit('saveActiveShow', item)
        this.headData = Object.keys(this.multipleData);
        this.footerData = Object.keys(this.multipleData[this.activeShow]);
      }
      if (item === '国家标准') {
        this.listParams.category = '2';
      }
      if (item === '行业标准') {
        this.listParams.category = '3';
      }

      this.fetchList();
    },
    chooseHeadInit (item) {
      if (item) {
        this.curItems = [];
        this.keyValue = [];
        this.listParams = {}
        this.activeShow = item;
        this.$store.commit('saveActiveShow', item)
        this.headData = Object.keys(this.multipleData);
        this.footerData = Object.keys(this.multipleData[this.activeShow]);
      }
      if (item === '国家标准') {
        this.listParams.category = '2';
      }
      if (item === '行业标准') {
        this.listParams.category = '3';
      }
    },
    removeCurItem (item, index) {
      // this.$nextTick(() => {
      //   this.curItems.splice(index, 1);
      // })
      if (this.selectName) {
        this.selectName = ''
      }
      switch (item.type) {
        case 'provinceCode':
          delete this.listParams.provinceCode;
          this.deleteItem(item)
          break;
        case 'level':
          delete this.listParams.level;
          this.deleteItem(item)
          break;
        case 'trade':
          delete this.listParams.trade;
          this.deleteItem(item)
          break;
        case 'state':
          delete this.listParams.state;
          this.deleteItem(item)
          break;
        case 'domain':
          delete this.listParams.domain;
          this.deleteItem(item)
          break;
        case 'category':
          delete this.listParams.category;
          this.deleteItem(item)
          break;
      }
    },
    deleteItem (item) {
      if (item.type === 'category') {
        this.curItems = []
        this.listParams = {}
      } else {
        this.curItems.forEach(element => {
          this.curItems.splice(this.curItems.indexOf(item), 1)
        });
      }
      this.fetchList()
    },
    handleSearch () {
      if (this.paramsData.issueDate) {
        this.paramsData.issueDate = this.dateFormat(this.paramsData.issueDate)
      }
      this.listParams = this.paramsData;
      // if (!this.$store.state.isTopNav) {
      this.fetchList();
      // }
    },
    reset () {
      this.paramsData = {};
    },
    handleSecondSearch () {
      this.listParams = this.paramsSecondData;
      this.fetchList();
    },
    secondReset () {
      this.paramsSecondData = {};
    },
    removeAllCurItem () {
      this.keyValue = []
      this.curItems = [];
      this.listParams = {};
    },
    pushCurItem (itemObj, item) {
      this.itemName = item;
      this.itemObjData = itemObj;
      this.curItems.forEach(element => {
        if (element.type === this.itemObjData.type) {
          this.curItems.splice(this.curItems.indexOf(element), 1)
        }
      });
      this.curItems.push(itemObj);
      this.curItems = Array.from(new Set(this.curItems));
      // this.keyValue.push(item);
      // this.keyValue = Array.from(new Set(this.keyValue));
      // if (this.curItems.length > 0) {
      //   for (const element of this.curItems) {
      //     if (element.hasOwnProperty(item)) {
      //       this.curItems.splice(this.curItems.indexOf(element), 1, {
      //         [item]: itemObj
      //       });
      //       break;
      //     } else {
      //       if (this.curItems.length < this.footerData.length) {
      //         this.curItems.push({ [item]: itemObj });
      //       } else {
      //         this.curItems.splice(this.curItems.indexOf(element) - 1, 1, {
      //           [item]: itemObj
      //         });
      //       }
      //     }
      //   }
      // } else {
      //   this.curItems.push({ [item]: itemObj });
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.multiple-wrap {
  width: @body-width;
  box-shadow: 0 0 2px @color-gray;
  margin: 0 auto;
  background: #fff;
  .mul-head {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 54px;
    background: #f5f5f5;
    .active {
      color: @color-base;
      background: #ffffff;
      border-bottom: 1px solid #ffffff;
      border-right: 1px solid RGBA(235, 237, 240, 1);
      border-left: 1px solid RGBA(235, 237, 240, 1);
    }
    .mul-head-item {
      padding: 16px 24px;
      border: 1px solid #f5f5f5;
    }
    .mul-head-item:hover {
      cursor: pointer;
      color: @color-blue;
      background: #ffffff;
      border-bottom: 1px solid #ffffff;
      border-right: 1px solid RGBA(235, 237, 240, 1);
      border-left: 1px solid RGBA(235, 237, 240, 1);
    }
  }
  .mul-content {
    // height: 58px;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px dashed @color-gray;
    .content-title {
      display: inline-block;
      padding: 16px 24px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 22px;
      width: 120px;
    }
    .cur-content {
      width: 1000px;
      font-size: 12px;
      font-weight: 500;
      color: @color-base;
      display: flex;
      justify-content: flex-start;
      align-items: space-around;
      flex-wrap: wrap;
      align-content: space-around;
      padding: 0 10px;
      cursor: pointer;
      .cur-item {
        margin-top: 1px;
        border: 1.5px solid @color-base;
        display: inline-block;
        height: 26px;
        padding: 0 10px;
        line-height: 24px;
        margin-left: 10px;
      }
      .remove-item-all {
        position: absolute;
        right: 20px;
        display: inline-block;
        height: 26px;
        line-height: 26px;
      }
    }
  }
  .mul-footer {
    position: relative;
    .footer-title {
      color: @color-gray;
      // padding: 16px 24px 16px 80px;
      margin-left: 80px;
      display: flex;
      justify-content: flex-start;
      align-items: space-around;
      flex-wrap: wrap;
      align-content: space-around;
      padding: 0 10px;
      .domain-cer {
        padding-top: 6px;
        padding-bottom: 24px;
        border: none;
        select {
          height: 32px;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          border: 1px solid @color-base;
          color: rgba(0, 0, 0, 0.55)
        }
      }
      .flex-content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 120px;
        flex-wrap: wrap;
      }
      .button-wraper {
        display: flex;
        justify-content: space-between;
        height: 40px;
        align-items: center;
        .tip-content {
          span {
            padding: 0;
          }
        }
        .button-content {
          .primary {
            width: 65px;
            height: 32px;
            background: @color-base;
            border-radius: 4px;
            color: #ffffff;
            margin: 0;
            padding: 0;
            border: 1px solid transparent; //自定义边框
            outline: none;
            margin-right: 4px;
          }
          .normal {
            width: 65px;
            height: 32px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid rgba(217, 217, 217, 1);
            color: #000000;
            margin: 0;
            padding: 0;
            outline: none;
            margin-right: 14px;
          }
        }
      }
      .inline-item {
        width: 300px;
        label{
          font-weight:400;
          color:rgba(0,0,0,0.65);
        }
        input {
          width: 200px;
          height: 32px;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          color:black;
        }
        .date-picker {
          width: 200px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          .datepicker {
            border-radius: 4px;
            width: 198px;
            height: 28px;
            top: 1px;
            /deep/input {
              border: none;
              // width: 150px;
              height: 28px !important;
              width: 198px;
            }
          }
        }
      }
      .date-picker {
        display: inline-block;
        z-index: 999;
      }
      .footer-title-name {
        display: inline-block;
        position: absolute;
        padding-top: 13px;
        left: 24px;
        .item-select {
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
          /*以上三项,为清除select自带样式*/
          background-origin: content-box;
          background-size: 16px; //这个自己重写成适合的大小
          padding: 0 8px;
          line-height: 34px;
          // border-radius: 3px;
          // border: solid 1px #dbdbdb;
          // color: #666;
          cursor: pointer;
          width: 240px;
          height: 32px;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px 4px 0px 0px;
          border: 1px solid @color-base;
          box-shadow: 0 6px 10px 0 rgba(0, 141, 255, 0.1);
        }
        // top: 12px;
      }
      span {
        color: @color-black;
        padding: 12px 16px;
        cursor: pointer;
      }
      span:hover {
        color: @color-blue;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/multipleFilter.vue